import React from 'react'

import config from '../config.js'

class Participants extends React.Component {
  render() {
    return this.props.participants.map(participant => {
      if (participant.accountId !== this.props.aid) {
        return (
          <span key={participant.accountId} className="participant">
            <img
              src={
                participant.avatarUrl == null
                  ? config.baseUrl + '/assets/img/generic-avatar-small.png'
                  : participant.avatarUrl + '=s48-c'
              }
              alt={participant.displayName + ' Avatar'}
            />
            {this.props.participants.length < 3 ? (
              <span className="participant__name">
                <br />
                {participant.displayName}
              </span>
            ) : (
              ''
            )}
          </span>
        )
      } else return ''
    })
  }
}

export default Participants



// WEBPACK FOOTER //
// ./src/Components/Participants.js